import Icon from "hardcover-ui/components/Icon";
import Text from "hardcover-ui/components/Text";
import faStar from "icons/solid/star.svg";
import { roundRating } from "lib/numberUtils";
import RatingGraph from "./RatingsGraph";
import { PageSerializersBooksLayout } from "types/serializers";
import LocaleNumber from "components/ui/LocaleNumber";

export default function BookRatingDetails({ book }: { book: PageSerializersBooksLayout }) {
  if (book.ratingsCount === 0) {
    return <></>;
  }
  return (
    <div className="col-span-4 lg:col-span-2">
      <div className="flex flex-wrap gap-0.5 justify-between text-xs md:text-sm">
        <p className="inline text-sm font-semibold">
          <Text variant="secondary" className="mr-1">
            Ratings
          </Text>
          <LocaleNumber number={book.ratingsCount} />
        </p>
        <p className="inline text-sm font-semibold">
          <Text variant="secondary" className="mr-1">
            Average rating
          </Text>
          <Text>
            <span>{roundRating(book.rating)}</span>
            <Icon icon={faStar} className="fill-yellow-400 ml-1" size="sm" />
          </Text>
        </p>
      </div>

      <div>
        <RatingGraph
          rating={book.rating}
          ratingsDistribution={book.ratingsDistribution}
        />
        <div className="flex flex-row justify-between">
          <Text variant="secondary" size="sm">
            1
            <Icon icon={faStar} className="fill-yellow-400 ml-0.5" size="sm" />
          </Text>
          <Text variant="secondary" size="sm">
            5
            <Icon icon={faStar} className="fill-yellow-400 ml-0.5" size="sm" />
          </Text>
        </div>
      </div>
    </div>
  );
}
